import { useContext } from 'react';
import { DexResultsContext } from './dex-results-context';
import { IntegratedDexResultsReturn } from './use-integrated-dex-results';

export function useDexResults(): IntegratedDexResultsReturn {
    const value = useContext(DexResultsContext);
    if (!value) {
        throw new Error('Unexpectedly did not find DexResultsStore on context');
    }
    return value;
}
